import { render, staticRenderFns } from "./Notificacoes.vue?vue&type=template&id=afcd7f78"
import script from "./Notificacoes.vue?vue&type=script&lang=js"
export * from "./Notificacoes.vue?vue&type=script&lang=js"
import style0 from "./Notificacoes.vue?vue&type=style&index=0&id=afcd7f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports